import { ConceptNodeMap } from "../../Concepts.interface";

export const isNodeSelected = (
  id: string,
  selected: Set<string>,
  treeMap: ConceptNodeMap,
) => {
  let currentId: string | null = id;

  while (currentId) {
    if (selected.has(currentId)) {
      return true;
    }
    currentId = treeMap[currentId]?.parentId ?? null;
  }

  return false;
};
